// Giorni mostrati dalla settimana degli appuntamenti oltre al primo, in base alla larghezza
// dello slice responsive: 7 giorni sugli schermi larghi, fino a 3 su quelli stretti
export const getWeekRange = (width: number): number => {
  if (width > 600) return 6;
  else if (width > 500) return 5;
  else if (width > 400) return 4;
  else if (width > 300) return 3;
  else return 2;
};
